'use client';

import { useContext } from 'react';
import { twMerge } from 'tailwind-merge';

import { InventoryForm } from '@/components/Inventory/InventoryForm';
import { InventoryFormContext } from '@/contexts/InventoryFormContext';
import { getUnlockPriceLabel } from '@/tools/inventory';
import { faPhone } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IInventory } from '@lamesarv-sdk/types';
import { IDynamicsOptionSet } from '@/types/dynamicsForms';

interface PdpFormProps {
  item: IInventory;
  locationsOptionSet: IDynamicsOptionSet;
}

export const PdpForm = ({ item, locationsOptionSet }: PdpFormProps) => {
  const { buttonLabel } = getUnlockPriceLabel(item);
  const { openMobileInquire, submittedItems } = useContext(InventoryFormContext);

  const wasSubmitted = submittedItems.has(item.id);

  return (
    <>
      <div id="pdpform" className="bg-blue-50 pt-20 pb-[4.5rem] max-lg:hidden font-helvetica">
        <div className="flex flex-col container mx-auto gap-10 items-center">
          <h2 className="font-bold text-black-500 text-[2.25rem]">{buttonLabel}</h2>
          <div className="border border-black-200 rounded-md px-16 py-10 bg-white">
            <InventoryForm item={item} locationsOptionSet={locationsOptionSet} />
          </div>
        </div>
      </div>
      <div className="fixed py-4 px-5 bg-white shadow-[0px_-4px_10px_0px_#00000033] bottom-0 left-0 w-screen z-40 border-t border-black-350 flex gap-3 lg:hidden">
        {!wasSubmitted && (
          <button
            type="button"
            onClick={() => openMobileInquire(item)}
            className="rounded bg-blue-500 text-white font-bold py-3 flex items-center justify-center flex-1 hover:bg-blue-600"
          >
            {buttonLabel}
          </button>
        )}
        <a
          href="tel:877-641-8052"
          className={twMerge(
            'py-3 px-5 rounded border border-blue-500 hover:bg-blue-50 bg-white text-blue-500 flex items-center justify-center gap-2',
            wasSubmitted && 'flex-1',
          )}
        >
          <FontAwesomeIcon icon={faPhone} className="size-4" />
          <span className="font-bold">Let's talk</span>
        </a>
      </div>
    </>
  );
};
